import script from "./ReviewSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./ReviewSlider.vue?vue&type=script&setup=true&lang=js"

import "./ReviewSlider.vue?vue&type=style&index=0&id=28b0c551&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28b0c551"]])

export default __exports__